<template>
  <footer class="footernav-en">
    <div class="container">
      Copyright (c) {{copyrightYear}} Guangdong Tianan New Material Co., LTD
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      copyrightYear: "",
    };
  },
  mounted() {
    this.nowtime();
  },
  methods: {
    nowtime() {
      // 获取当前年份
      let year = new Date().getFullYear();
      this.copyrightYear = year;
    },
  },
};
</script>

<style scoped>
/*页脚*/
footer {
  background-color: #3d3e40;
  color: #fff;
  padding: 6px 0;
  text-align: center;
}

@media (min-width: 768px) {
  footer .container {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
